import "./LocationTestAndPanelsViewComponent.scss";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import EditIcon from "@mui/icons-material/Edit";
import React, { useEffect, useState} from "react";

interface LocationTestAndPanelsViewComponentProps {
    locationTestAndPanel: any;
    canEdit: boolean;
    onEditModeOpen: Function
}

const LocationTestAndPanelsViewComponent = (props: LocationTestAndPanelsViewComponentProps) => {
    const {locationTestAndPanel, canEdit, onEditModeOpen} = props;

    const [testAndPanel, setTestAndPanel] = useState<any>(undefined);

    useEffect(() => {
        if (locationTestAndPanel) {
            setTestAndPanel(locationTestAndPanel);
        }
    }, [locationTestAndPanel]);

    return (
        <div className={'location-test-and-panels-view-component details-tab-data-content'}>
            <div className="details-tab-data-header">
                <div className="view-and-edit-sub-title">Selected Test(s):</div>
                {canEdit &&
                    <div>
                        <ButtonComponent
                            className={"white-space-nowrap"}
                            type="button"
                            color={"primary"}
                            variant={"outlined"}
                            startIcon={<EditIcon/>}
                            fullWidth={true}
                            handleClick={() => {
                                onEditModeOpen(testAndPanel)
                            }}
                        >
                            Edit Details
                        </ButtonComponent>
                    </div>
                }
            </div>
            {
                testAndPanel?.testDetails?.length > 0 ?
                    <div>
                        {
                            testAndPanel?.testDetails?.map((test: any, index: number) => {
                                return (
                                    <div className={'test-or-panel-name'} key={index}>
                                       {test?.name}
                                    </div>
                                )
                            })
                        }
                    </div>
                :
                <div className="details-tab-data-body">
                    <div className="no-data-found">No Tests found</div>
                </div>
            }
            <div className={'horizontal-line'}></div>
            <div className={"view-and-edit-sub-title"}>Selected Test Panel(s):</div>
            {
                testAndPanel?.panelDetails?.length > 0 ?
                    <div>
                        {
                            testAndPanel?.panelDetails?.map((test: any, index: number) => {
                                return (
                                    <div className={'test-or-panel-name'} key={index}>
                                        {test?.name}
                                    </div>
                                )
                            })
                        }
                    </div>
                    :
                    <div className="details-tab-data-body">
                        <div className="no-data-found">No Panels found</div>
                    </div>
            }
        </div>
    );

};

export default LocationTestAndPanelsViewComponent;